"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validUrlQueryEndingChars = /[a-z0-9\-_&=#\/]/i;
exports.default = validUrlQueryEndingChars;
module.exports = exports["default"];